var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.pink)?_c('div',{staticClass:"group-box"},[_c('div',{staticClass:"poster",on:{"click":_vm.createPoster}},[_c('span',[_vm._v("生成专属海报")])]),_c('Poster',{attrs:{"show":_vm.showPosterPopup,"posterData":_vm.posterData},on:{"close":function($event){_vm.showPosterPopup=false}}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }